import router from './router'
import storage from 'store'
import NProgress from 'nprogress' // progress bar
import {ACCESS_TOKEN, PARENT_URL} from '@/store/mutation-types'
import store from "@/store";
NProgress.configure({ showSpinner: false }) // NProgress Configuration

router.beforeEach((to, from, next) => {
  if ((to.name === 'index' || to.path === '/goodsDetail') && to.query.token) {
    storage.set(ACCESS_TOKEN, to.query.token)
  }
  if ((to.name === 'index' || to.path === '/goodsDetail') && to.query.parentUrl) {
    storage.set(PARENT_URL, to.query.parentUrl)
  }
    NProgress.start() // start progress bar
  const token = storage.get(ACCESS_TOKEN)
  if (token) {
    next()
  } else {
    store.dispatch('Kickout')
  }
})

router.afterEach(() => {
  NProgress.done() // finish progress bar
})
